/* global Swiper */
// *******************************************************************************
// 1.0 - Gallery
// *******************************************************************************

const gallerySliderElements = document.querySelectorAll('[data-slider="gallery-slider"]');

const gallerySliderOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 800,
  loopAdditionalSlides: 30,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      spaceBetween: 20,
    },
  },
};

gallerySliderElements.forEach((el) => {
  const gallerySliderParent = el.closest('.sc-gallery');
  const arrowRight = gallerySliderParent.querySelector('.arrow-right');
  const arrowLeft = gallerySliderParent.querySelector('.arrow-left');

  gallerySliderOptions.navigation.nextEl = arrowRight;
  gallerySliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-new
  const gallerySlider = new Swiper(el, gallerySliderOptions);
});

// *******************************************************************************
// 1.2 - Open Gallery Modal
// *******************************************************************************

attachEvent('.gallery__image', 'click', (ev) => {
  const parentEle = ev.target.closest('.sc-gallery');
  const galleryModal = parentEle.querySelector('.gallery-modal');
  galleryModal.classList.add('is-open-modal');
});
